import type { RouteLocationNormalizedLoaded } from "vue-router";

/**
 * Full-page navigation to /home after authentication completes.
 * Uses window.location.assign (not Vue router) so the request hits
 * the server's userSpaShellHandler, which checks for auto-browse and
 * instant referrer redirects and 303s when applicable.
 */
export function postLoginNavigate(route: RouteLocationNormalizedLoaded): void {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(route.query)) {
    if (value != null) params.set(key, String(value));
  }
  const qs = params.toString();
  window.location.assign("/home" + (qs ? "?" + qs : ""));
}
